import React, { CSSProperties, PropsWithChildren } from 'react';
import { motion } from 'motion/react';
import usePlatform, { PlatformType } from '../../hook/usePlatform';

interface ResponsiveWrapperType {
  style?:CSSProperties,
  mobilePadding?:number | string,
  tabletPadding?:number | string,
  desktopPadding?:number | string,
  id?:string
}

const ResponsivePaddingWrapper: React.FC<PropsWithChildren<ResponsiveWrapperType>> = ({
  children, style, mobilePadding = 0, tabletPadding = '10vw', desktopPadding = '10vw', id,
}:PropsWithChildren<ResponsiveWrapperType>) => {
  const platform = usePlatform();
  const padding = platform === PlatformType.mobile
    ? mobilePadding : platform === PlatformType.tablet
      ? tabletPadding : desktopPadding;
  return (
    <motion.div
      id={id}
      style={{
        position: 'relative',
        ...style,
      }}
      initial={{
        paddingInline: padding,
      }}
      animate={{
        paddingInline: padding,
      }}
      layout
    >
      {children}
    </motion.div>
  );
};
type ResponsiveBorderType = ResponsiveWrapperType & {
  border:string,
};
export const ResponsivePaddingBorderWrapper: React.FC<PropsWithChildren<ResponsiveBorderType>> = ({
  children, style, mobilePadding = 0, tabletPadding = '10vw', desktopPadding = '15vw', border,
}:PropsWithChildren<ResponsiveBorderType>) => {
  const platform = usePlatform();
  const padding = platform === PlatformType.mobile
    ? mobilePadding : platform === PlatformType.tablet
      ? tabletPadding : desktopPadding;
  return (
    <div style={{ width: '100%', display: 'flex' }}>
      <motion.div
        style={{
          position: 'relative',
          borderBottom: border,
        }}
        initial={{
          width: padding,
        }}
        animate={{
          width: padding,
        }}
        layout
      />
      <div style={{ flex: 1, ...style }}>
        {children}
      </div>
      <motion.div
        style={{
          position: 'relative',
          borderBottom: border,
        }}
        initial={{
          width: padding,
        }}
        animate={{
          width: padding,
        }}
      />

    </div>

  );
};

type FlexDirectionType = ResponsiveWrapperType & {
  mobileDirection?: any,
  defaultDirection?: any,
};

export const ResponsiveFlexDirection: React.FC<PropsWithChildren<FlexDirectionType>> = ({
  style,
  mobileDirection = 'column',
  defaultDirection = 'row',
  children,
}: PropsWithChildren<FlexDirectionType>) => {
  const platform = usePlatform();
  return (
    <div style={{
      display: 'flex',
      flexDirection: platform === PlatformType.mobile ? mobileDirection : defaultDirection,
      ...style,
    }}
    >
      {children}
    </div>
  );
};
export default ResponsivePaddingWrapper;
